/* ============================================================
   VEJI — Typographie française (#1 + #3)
   Corrige les nœuds texte du DOM après rendu :
   - apostrophes droites → courbes (’)
   - guillemets droits "…" → chevrons « … » avec espaces fines
   - espaces fines insécables (U+202F) avant ; ! ? et autour des chevrons
   - espace insécable (U+00A0) avant : € %  et dans les grands nombres
   N'altère JAMAIS le code, les champs de saisie, les scripts/styles.
   Idempotent : ne retraite pas un texte déjà corrigé.
   ============================================================ */
(function () {
  'use strict';

  var NNBSP = ' '; // espace fine insécable
  var NBSP = ' ';  // espace insécable

  // Conteneurs dont le contenu textuel ne doit pas être touché.
  var SKIP_TAGS = {
    SCRIPT: 1, STYLE: 1, TEXTAREA: 1, CODE: 1, PRE: 1, KBD: 1,
    SAMP: 1, INPUT: 1, SELECT: 1, OPTION: 1, NOSCRIPT: 1
  };

  function fixText(s) {
    if (!s || !/\S/.test(s)) return s;

    // Apostrophe droite après une lettre → courbe (d'abord, l'eau, qu'on…)
    s = s.replace(/([A-Za-zÀ-ÖØ-öø-ÿ])'/g, '$1’');

    // Guillemets droits appariés → chevrons français + fines insécables
    s = s.replace(/"([^"]*)"/g, function (_, inner) {
      return '«' + NNBSP + inner.trim() + NNBSP + '»';
    });

    // Espace fine insécable avant ; ! ? (pas les "!!" ni "?!" multiples : on
    // normalise l'espace qui précède le groupe de ponctuation)
    s = s.replace(/\s*([;!?])/g, NNBSP + '$1');

    // Deux-points : espace insécable (règle FR : NBSP avant « : »)
    s = s.replace(/\s*:(\s|$)/g, NBSP + ':$1');

    // Unités monétaires / pourcentage : NBSP entre le nombre et le symbole
    s = s.replace(/(\d)\s*([€%])/g, '$1' + NBSP + '$2');

    return s;
  }

  function alreadyFixed(s) {
    return s.indexOf(NNBSP) !== -1 ||
           s.indexOf('’') !== -1 ||
           s.indexOf('«') !== -1;
  }

  function walk(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || SKIP_TAGS[p.nodeName]) return NodeFilter.FILTER_REJECT;
        if (p.isContentEditable) return NodeFilter.FILTER_REJECT;
        if (alreadyFixed(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        return /\S/.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });

    var batch = [];
    var n;
    while ((n = walker.nextNode())) batch.push(n);
    batch.forEach(function (node) {
      var fixed = fixText(node.nodeValue);
      if (fixed !== node.nodeValue) node.nodeValue = fixed;
    });
  }

  function run() {
    walk(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
